import styles from "./sass-theme.module.scss";
import { Theme } from "./theme";

/** The default theme to use in the dashboard, or other environments where Sass is available (ie, not the reporting site) */
const theme: Theme = { styles, stringFallback: false };

export default theme;
